import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './Footer.css';

const Footer = () => {
    const { t } = useLanguage();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <h3 className="footer-title">
                            <span className="footer-logo">🚕</span>
                            elittaksibodrum.com
                        </h3>
                        <p className="footer-description">
                            {t('welcomeSubtitle')}
                        </p>
                    </div>

                    <div className="footer-section">
                        <h4 className="footer-heading">{t('contact')}</h4>
                        <ul className="footer-links">
                            <li>📧 elittaksibodrum@gmail.com</li>
                            <li>📱 0537 976 06 51</li>
                            <li>📍 Bodrum, Türkiye</li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {currentYear} elittaksibodrum.com - {t('allRightsReserved')}</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
